import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

import { fuseAnimations } from 'admin/@fuse/animations';
import { DevAccountService } from '../services/accountService';
import { BaseCompanySignup } from 'admin/baseLogin/BaseCompanySignup';

@Component({
    selector: 'company-signup',
    template: require('./company-signup.component.html'),
    styles: [require('./company-signup.component.scss')],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class DevCompanySignupComponent extends BaseCompanySignup
{
    constructor(
        protected router: Router,
        protected accountService: DevAccountService)
    {
        super(
            router,
            accountService,
            "/app/dev",
            "/account/dev");
    }
}
